import type { SizeGuideEntry, SizeGuideList } from '../../types'

export function sortEquivalences(
	equivalences: SizeGuideList[]
): SizeGuideList[] {
	return equivalences.map((equivalence) => {
		const sortedSizeGuides = equivalence.sizeGuides.map((sizeGuide) => {
			const sortedKeys = Object.keys(sizeGuide).sort((a, b) =>
				a.localeCompare(b)
			)
			const sortedSizeGuide: { [key: string]: SizeGuideEntry[] } = {}
			sortedKeys.forEach((key) => {
				sortedSizeGuide[key] = sizeGuide[key]
			})

			return sortedSizeGuide
		})

		return {
			...equivalence,
			sizeGuides: sortedSizeGuides,
		}
	})
}
